<!--<md-nav-bar class="md-primary md-hue-2" md-selected-nav-item="vm.currentNavItem" nav-bar-aria-label="navigation links">
  <md-nav-item md-nav-sref="home.ajuntaments.ajuntament.informacio" name="informacio">Informació</md-nav-item>
  <md-nav-item md-nav-sref="home.ajuntaments.ajuntament.entitats" name="entitats">Entitats</md-nav-item>
</md-nav-bar>-->

<div ui-view></div>
